import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/menu',
      name: 'menu',
      component: () => import('./views/Menu.vue')
    },
    {
      path: '/rank/:raceID/:sport',
      name: 'live',
      component: () => import('./views/Live.vue')
    },
    {
      path: '/randomOld/:raceID/:token',
      name: 'random',
      component: () => import('./views/LiveRandom.vue')
    },
    {
      path: '/random/:raceID/:token',
      name: 'random2',
      component: () => import('./views/LiveRandom2.vue')
    },
    {
      path: '/adminrandom/:raceID/:token',
      name: 'adminrandom',
      component: () => import('./views/AdminRandom.vue')
    },
    {
      path: '/laps/:raceID/:divisione/:numril',
      name: 'laps',
      component: () => import('./views/LiveMultilap.vue')
    },
    {
      path: '/passaggi/:raceID',
      name: 'passaggi',
      component: () => import('./views/Passaggi.vue')
    },
    {
      path: '/rank/ultra/:raceID/:divisione',
      name: 'rankultra',
      component: () => import('./views/LiveUltra.vue')
    },
    {
      path: '/virtual/:raceID/:sponsor',
      name: 'virtual',
      component: () => import('./views/Virtual.vue')
    },
    {
      path: '/booking/:raceID/:dataPrenotazione',
      name: 'booking',
      component: () => import('./views/Booking.vue')
    },
    {
      path: '/generic/:raceID/',
      name: 'generic',
      component: () => import('./views/Generica.vue')
    },
    {
      path: '/remote/:raceID/:id',
      name: 'remote',
      component: () => import('./views/Remote.vue')
    },
    {
      path: '/remote2/:raceID/:id',
      name: 'remote2',
      component: () => import('./views/Remote2.vue')
    },
    {
      path: '/remote2/:raceID/:id/:local',
      name: 'remote2local',
      component: () => import('./views/Remote2.vue')
    },
    {
      path: '/clock/:raceID/:id/:local',
      name: 'clockLocal',
      component: () => import('./views/Clock.vue')
    },
    {
      path: '/clock/:raceID/:id/',
      name: 'clock',
      component: () => import('./views/Clock.vue')
    },
    {
      path: '/tracker/:raceID/:id/:local',
      name: 'tracker',
      component: () => import('./views/Tracker.vue')
    },
    {
      path: '/trackerconsole/:raceID/:id/',
      name: 'trackerconsole',
      component: () => import('./views/TrackerConsole.vue')
    },
    {
      path: '/trackerconsole/:raceID/:id/:local',
      name: 'trackerconsoleLocal',
      component: () => import('./views/TrackerConsole.vue')
    },
    {
      path: '/trackme/:raceID',
      name: 'trackme',
      component: () => import('./views/TrackMe.vue')
    },
    {
      path: '/remoteconfig/:raceID/:id/:token',
      name: 'remoteconfig',
      component: () => import('./views/RemoteConfig.vue')
    },
   {
      path: '/classifica/:raceID/:id/:local',
      name: 'classifica',
      component: () => import('./views/Classifica.vue')
    },
    {
      path: '/classificacircuito/:raceID/:id/:local',
      name: 'classificacircuito',
      component: () => import('./views/ClassificaCircuito.vue')
    },
    {
      path: '/checkpoint/',
      name: 'checkpoint',
      component: () => import('./views/Checkpoint.vue')
    },
    {
      path: '/stream/:raceID/:id/:local',
      name: 'stream',
      component: () => import('./views/Stream.vue')
    },
    {
      path: '/led/:raceID/:id/:local',
      name: 'ledLocal',
      component: () => import('./views/Lednew.vue')
    },
    {
      path: '/led/:raceID/:id',
      name: 'led',
      component: () => import('./views/Lednew.vue')
    },
    {
      path: '/led2/:raceID/:id/:local',
      name: 'led2',
      component: () => import('./views/Led2.vue')
    },
    {
      path: '/premiazioni/:raceID/:id/:local',
      name: 'premiazioni',
      component: () => import('./views/Premiazioni.vue')
    },
    {
      path: '/remote/:raceID/:id/:local',
      name: 'remoteLocal',
      component: () => import('./views/Remote.vue')
    },
    {
      path: '/tzero/:raceID/:id',
      name: 'tzero',
      component: () => import('./views/TZero.vue')
    },
    {
      path: '/controller/:channel',
      name: 'controller',
      component: () => import('./views/LiveTVController.vue')
    },
    {
      path: '/rr/:icronID/:raceID/:token',
      name: 'rr',
      component: () => import('./views/RR.vue')
    },
    {
      path: '/tv2/:raceID/:id/:local',
      name: 'tvLocal',
      component: () => import('./views/TV.vue')
    },
    {
      path: '/tv2/:raceID/:id',
      name: 'tv',
      component: () => import('./views/TV.vue')
    },
    {
      path: '/aricp',
      name: 'aricp',
      component: () => import('./views/AriCP.vue')
    },
    {
      path: '/tabellone/:raceID',
      name: 'Tabellone',
      component: () => import('./views/Tabellone.vue')
    },
    {
      path: '/tabellone/:raceID/:id',
      name: 'Tabellone2',
      component: () => import('./views/Tabellone.vue')
    },
    {
      path: '/icronium2/:reportId',
      name: 'Icronium',
      component: () => import('./views/Live.vue')
    },
    /*{
      path: '/tv/:raceID/:id/:tag',
      name: 'tv',
      component: () => import('./views/LiveTV.vue')
    },*/
    {
      path: '/dashboard/',
      name: 'dashboard',
      component: () => import('./views/Dashboard.vue')
    },
    {
      path: '/self/:reportId',
      name: 'self',
      component: () => import('./views/Kiosk.vue')
    },
    {
      path: '/devices/',
      name: 'devices',
      component: () => import('./views/Devices.vue')
    },
    {
      path: '/icronium2/rank/:reportId',
      name: 'icroniumrank',
      component: () => import('./views/LiveSequenziale.vue')
    },
    {
      path: '/icronium/:eventId/:reportId',
      name: 'icroniumrr',
      component: () => import('./views/LiveSequenzialeRR.vue')
    },
    {
      path: '/event/:reportId',
      name: 'event',
      component: () => import('./views/LiveHome.vue')
    },
    {
      path: '/icronium2/rankhome/:reportId',
      name: 'icroniumrankhome',
      component: () => import('./views/LiveHome.vue')
    },
    {
      path: '/remoteattivo/:raceID/:id/:local',
      name: 'remoteattivoLocal',
      component: () => import('./views/RemoteAttivo.vue')
    },
    {
      path: '/remoteattivo/:raceID/:id',
      name: 'remoteattivo',
      component: () => import('./views/RemoteAttivo.vue')
    },
    {
      path: '/remoteattivopublic/:raceID/:id/:local',
      name: 'remoteattivopublicLocal',
      component: () => import('./views/RemoteAttivoPublic.vue')
    },
    {
      path: '/remoteattivopublic/:raceID/:id',
      name: 'remoteattivopublic',
      component: () => import('./views/RemoteAttivoPublic.vue')
    },

    {
      path: '/remoteattivostack/:raceID/:id/:local',
      name: 'remoteattivostackLocal',
      component: () => import('./views/RemoteAttivoStack.vue')
    },
    {
      path: '/remoteattivostack/:raceID/:id',
      name: 'remoteattivostack',
      component: () => import('./views/RemoteAttivoStack.vue')
    },

    {
      path: '/remoteattivonew/:raceID/:id/:local',
      name: 'remoteattivonewLocal',
      component: () => import('./views/RemoteAttivoNew.vue')
    },
    {
      path: '/remoteattivonew/:raceID/:id',
      name: 'remoteattivonew',
      component: () => import('./views/RemoteAttivoNew.vue')
    },


    {
      path: '/startinglist/:raceID/:id/:local',
      name: 'startinglistLocal',
      component: () => import('./views/StartingList.vue')
    },
    {
      path: '/startinglist/:raceID/:id',
      name: 'startinglist',
      component: () => import('./views/StartingList.vue')
    },



    
    {
      path: '/ggg/:raceID/:id/:token',
      name: 'ggg',
      component: () => import('./views/GGG.vue')
    },
    {
      path: '/ggg/:raceID/:id/:token/:local',
      name: 'ggglocal',
      component: () => import('./views/GGG.vue')
    },
   {
      path: '/labels/:raceID',
      name: 'LabelsNoid',
      component: () => import('./views/Labels.vue')
    },

  ]
});

/*
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.authRequired)) {
        if (!store.state.isAuthenticated) {
            next({
                path: '/sign-in'
            });
        } else {
            next();
        }
    } else {
        next();
    }
});
*/

export default router;
